import {Component, OnInit} from '@angular/core';
import {RegistriesService} from '../../service';
import {ActivatedRoute, Router} from '@angular/router';
import {FromuSubject} from "../../model";
import {AccessJson, FromuFilter} from "@amlCore/models";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {TableService, UserService, VisitedService} from "@amlCore/services";
import {Utils} from "@amlCore/utils";
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {IDataResponse} from "@amlCore/interfaces";


@Component({
  selector: 'app-registry-fromu-list',
  templateUrl: './fromuList.component.html'
})
export class FromuListComponent extends TableReactiveUrlController implements OnInit {

  isShowVisited = true;

  constructor(private regSrv: RegistriesService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'name', dir: 'ASC', filter: new FromuFilter()});
  }

  public dataList: FromuSubject[] = [];
  public isAll = true;
  public access: AccessJson;
  public goBack = Utils.goBack;
  private id: string;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_MVK);
    this.activatedRoute.params.subscribe(params => {
      this.id = params.id;
      this.activatedRoute.queryParams.subscribe(data => {
        this.isAll = !this.id;
        const paramsData = this.syncParams(data);
        paramsData.id = this.id;
        this.loadList(paramsData);
      });
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: FromuFilter) {
    const filter = this.tableService.getFilterSubject(data) as FromuFilter;
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params: FromuFilter): void {
    const filter = this.getParams({...params, ...this.filter}) as FromuFilter;
    filter['isAll'] = this.isAll;
    this.navigate(filter);
  }

  public onSearch(): void {
    const params = this.getSearchPage(this.filter) as FromuFilter;
    this.onPageChange(params);
  }

  private loadList(params?: FromuFilter): void {
    this.regSrv.getFromuList(this.getParams(params)).subscribe((data: IDataResponse<FromuSubject>) => {
      this.dataList = data.content;
      this.total = data.totalElements;
    });
  }

  getIdOfBase(item: FromuSubject): string {
    return item.base ? item.id : item.parentId;
  }
}
